<template>
  <section class="primaryInfo">
    <a
      name="home"
      style="
        position: relative;
        top: -420px;
        display: block;
        height: 0;
        overflow: hidden;
      "
    ></a>
    <section class="information">
      <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>
      <section class="innerBox">
        <div class="leftMenu">
          <li
            @click="directToHandle(leftItem.anchorId)"
            :class="[
              'menu-item',
              isActive === leftItem.anchorId ? 'menu-item--active' : '',
            ]"
            v-for="(leftItem, idx) in leftMenus"
            :key="idx"
          >
            {{ leftItem.title }}
          </li>
        </div>
        <div class="info">
          <ul class="crumbs_container">
            <li
              class="crumbs_item"
              v-for="(routeItem, routeIdx) in crumbsList"
              :key="routeIdx"
              @click="gotoHandle(routeItem.routeName)"
            >
              {{ routeItem.label }}
              <span v-if="routeIdx < crumbsList.length - 1">></span>
            </li>
          </ul>
          <h3>Updates: Terms of use</h3>
          <ul class="version_container">
            <li
              class="version_item"
              v-for="(versionItem, versionIdx) in versionList"
              :key="versionIdx"
            >
              <a :href="`/${versionItem.routeName}`">{{ versionItem.label }}</a>
            </li>
          </ul>
        </div>
        <!-- <div class="cp">All rights reserved, 2020 © Totok Pte. Ltd.</div> -->
      </section>
    </section>
  </section>
</template>

<script>
import NavCrumbs from "@/components/NavCrumbs.vue";
export default {
  metaInfo() {
    return {
      title: "Privacy Policy - ToTok Messenger",
      meta: [
        {
          Description:
            "To check how ToTok collect and process your data, please read our privacy policy carefully",
        },
        { property: "og:title", content: "Privacy Policy - ToTok Messenger" },
        { property: "og:url", content: "https://totok.ai/privacy" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        {
          property: "og:description",
          content:
            "Enjoy FREE, FAST and FUN calling with your family and friends.",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  components: {
    NavCrumbs,
  },
  data() {
    return {
      crumbProp: {
        label: "Privacy & Terms",
        type: "simple",
      },
      archivedVersionLabel: "archived versions",
      mainPannel: "",
      showinfo: false,
      isActive: "terms",
      leftMenus: [
        {
          title: "Terms of Use",
          anchorId: "terms",
        },
        {
          title: "Privacy Policy",
          anchorId: "privacy",
        },
      ],
    };
  },
  computed: {
    info() {
      return [];
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
    crumbsList() {
      return [
        {
          label: "Privacy & Terms",
          routeName: "terms",
        },
        {
          label: "Updates: Terms of use",
          routeName: "archivedterms",
        },
      ];
    },
    versionList() {
      return [
        {
          label: "Current version",
          routeName: "terms",
        },
        {
          label: "May 2020",
          routeName: "terms-may",
        },
        {
          label: "March 2020",
          routeName: "terms-march",
        },
        {
          label: "August 2019",
          routeName: "terms-dec29",
        },
      ];
    },
  },
  methods: {
    directToHandle(item) {
      switch (item) {
        case "terms":
          this.isActive = "terms";
          this.$router.push("terms");
          break;
        case "privacy":
          this.isActive = "privacy";
          this.$router.push("privacy");
          break;
      }
    },
    gotoHandle(routeName) {
      this.$router.push({
        name: routeName,
      });
    },
  },
  mounted() {
    this.mainPannel = document.getElementById("mainbox");
  },
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
  .primaryInfo {
    padding: 0.8rem;
    // background: #fff;
    height: 82vh;

    div {
      margin-left: 20px;
      margin-right: 20px;
    }

    .info {
      margin-top: 30px;

      h1 {
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 28px;
        font-weight: 400;
        color: #222222;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 20px;
        padding-top: 40px;
        margin: 0px;
        line-height: 40px;
      }

      h2 {
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 24px;
        font-weight: 400;
        color: #4377f2;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 18px;
        padding-top: 28px;
        margin: 0px;
      }

      h3 {
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 16px;
        font-weight: 400;
        color: #808080;
        padding-bottom: 20px;
        margin: 0;
      }

      p {
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-bottom: 12px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      ul {
        list-style: disc;
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0;
        margin-bottom: 10px;
        margin-left: 24px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      li {
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0px;
        margin-bottom: 10px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
        margin-left: 20px;
      }

      a {
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0px;
        margin-bottom: 10px;
        color: #4377f2;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      .crumbs_container {
        display: flex;
        justify-content: flex-start;
        list-style: none;
        margin-left: 0px;

        .crumbs_item {
          color: #4377f2;
          font-size: 12px;
          cursor: pointer;

          span {
            margin-left: 20px;
            color: #808080;
          }
        }

        .crumbs_item:nth-child(1) {
          margin-left: 0px;
        }

        .crumbs_item:nth-last-child(1) {
          color: #808080;
        }
      }
    }

    .leftMenu {
      display: none;
    }
  }

  .cp {
    position: absolute;
    margin: 0 auto;
    width: 80%;
    bottom: 10px;
    height: 3.5rem;
    font-size: 13px;
    color: #808080;
    line-height: 3.5rem;
    text-align: center;
  }
}

@media only screen and (min-width: 701px) {
  .primaryInfo {
    padding-top: 102px;
    width: 100vw;
    background: #fff;

    .information {
      margin: 0 auto;
      width: 800px;

      .innerBox {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        width: 800px;
        min-height: 83vh;
        overflow: auto;

        .leftMenu {
          position: absolute;
          left: 0px;
          top: 39px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          list-style: none;

          .menu-item {
            color: #979797;
            margin-top: 30px;
            cursor: pointer;
            text-decoration: none;
            font-size: 15px;
          }

          .menu-item:nth-child(1) {
            margin-top: 0px;
          }

          .menu-item--active {
            color: #000;
            border-bottom: 2px solid #4377f2;
          }
        }
      }
    }

    .info {
      width: 620px;
      margin: 20px 0;

      h1 {
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 28px;
        font-weight: 400;
        color: #222222;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 20px;
        padding-top: 20px;
        margin: 0px;
        line-height: 40px;
      }

      h2 {
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 24px;
        font-weight: 400;
        color: #4377f2;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 18px;
        padding-top: 28px;
        margin: 0px;
      }

      h3 {
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 16px;
        font-weight: 400;
        color: #808080;
        padding-bottom: 20px;
        margin: 0;
      }

      p {
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-bottom: 12px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      ul {
        list-style: disc;
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0;
        margin-bottom: 10px;
        margin-left: 24px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      li {
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0px;
        margin-bottom: 10px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
        margin-left: 20px;
      }

      a {
        font-family: 'sofiapro-regular', 'Calibri Light', 'Helvetica Neue', Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0px;
        margin-bottom: 10px;
        color: #4377f2;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }
    }
  }

  .crumbs_container {
    display: none;
  }

  .cp {
    height: 70px;
    font-size: 13px;
    color: #808080;
    line-height: 70px;
    text-align: center;
  }
}
</style>
